import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${setHoursEndOfDate(params.FechaHasta)}`);
  params.Estado &&
    params.Estado.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.Estado.Codigo}`);
  if (params.FiltroVigencia) {
    const valorVigencia = params.FiltroVigencia.Codigo || params.FiltroVigencia;
    path = `${path !== '' ? `${path}&` : ''}FiltroVigencia=${valorVigencia}`;
  }
  params.CodigoUsuarioCreacion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsuarioCreacion=${params.CodigoUsuarioCreacion}`);
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}Cliente=${params.Cliente}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.FechaEstadoDesde &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoDesde=${params.FechaEstadoDesde}`);
  params.FechaEstadoHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoHasta=${setHoursEndOfDate(params.FechaEstadoHasta)}`);
  params.CodigoEspecificacionTecnica &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEspecificacionTecnica=${params.CodigoEspecificacionTecnica}`);
  params.AllRequest && (path = `${path !== '' ? `${path}&` : ''}AllRequest=${params.AllRequest}`);
  params.CodigoSuaje &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoSuaje=${params.CodigoSuaje}`);
  if (params.ElementoTipo && !Array.isArray(params.ElementoTipo) && params.ElementoTipo.Codigo) {
    path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${encodeURIComponent(params.ElementoTipo.Codigo)}`;
  }
  params.SinCliente && (path = `${path !== '' ? `${path}&` : ''}SinCliente=${params.SinCliente}`);
  params.CodigoCliente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCliente=${params.CodigoCliente}`);
  if (Array.isArray(params.CodigoClientes) && params.CodigoClientes.length) {
    params.CodigoClientes.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoClientes=${encodeURIComponent(codigo)}`;
    });
  }
  if (Array.isArray(params.ElementoTipo) && params.ElementoTipo.length) {
    const codigosElementoTipo = params.ElementoTipo.map((tipo) =>
      tipo && typeof tipo === 'object' ? tipo.Codigo : tipo,
    )
      .map((c) => Number(c))
      .filter((c) => Number.isFinite(c) && c > 0);

    codigosElementoTipo.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${encodeURIComponent(codigo)}`;
    });
  }
  params.CodigoEquivalente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEquivalente=${params.CodigoEquivalente}`);
  params.version && (path = `${path !== '' ? `${path}&` : ''}version=${params.version}`);
  params.CodigoAdicional &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoAdicional=${params.CodigoAdicional}`);
  params.CodigoUsabilidad &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsabilidad=${params.CodigoUsabilidad}`);
  params.CodigoET &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoET=${encodeURIComponent(params.CodigoET)}`);
  params.DescripcionComercial &&
    (path = `${path !== '' ? `${path}&` : ''}DescripcionComercial=${encodeURIComponent(params.DescripcionComercial)}`);
  if (params.Procesos && Array.isArray(params.Procesos) && params.Procesos.length > 0) {
    const codigosProcesos = params.Procesos.map((p) => p.Codigo || p);
    const stringProcesos = codigosProcesos.join(',');
    path = `${path !== '' ? `${path}&` : ''}Procesos=${encodeURIComponent(stringProcesos)}`;
  }
  return path;
};

const setHoursEndOfDate = (fecha) => {
  if (fecha) {
    const fechaSeleccionada = new Date(fecha);
    fechaSeleccionada.setHours(23, 59, 59, 999);
    return fechaSeleccionada;
  }
  return fecha;
};
